<template>
	<div id="casiola-app-search-modal">
		<button aria-label="close" @click.stop.prevent="close">
			<i class="fas fa-times"></i>
		</button>
		<form class="location" @submit.prevent>
			<div class="app-container">
				<h3>Destination</h3>
				<ul>
					<li v-for="destination in destinations" :key="destination.id">
						<label>
							<input type="radio" name="destination" v-model="dest" :value="destination.id" />
							<span>{{ destination.name }}</span>
						</label>
					</li>
					<li key="all">
						<label>
							<input type="radio" name="destination" v-model="dest" value="all" />
							<span>All destinations</span>
						</label>
					</li>
				</ul>
			</div>
		</form>
		<form class="date" @submit.prevent>
			<div class="app-container">
				<calendar :months="{'lg':2}" direction="row" :uid="casiola.state.selectedUnit?.id" v-model="casiola.state.baseFilters.date"/>
			</div>
		</form>
		<form class="guests" @submit.prevent>
			<div class="app-container">
				<h3 v-html="'Guests' + (totalGuests ? ` - <strong>${totalGuests}</strong>` : '')"></h3>
				<ul>
					<li>
						<div class="desc">
							<span class="label">Adults (12+)</span>
							<span class="body">Ages 13 and above</span>
						</div>
						<div class="counter">
							<vue-number-input v-model="casiola.state.baseFilters.guests.adults" :min="0" size="small"
								inline controls placeholder="0" :inputtable="false"></vue-number-input>
						</div>
					</li>
					<li>
						<div class="desc">
							<span class="label">Children</span>
							<span class="body">Ages 0 - 12</span>
						</div>
						<div class="counter">
							<vue-number-input v-model="casiola.state.baseFilters.guests.children" :min="0" size="small"
								inline controls placeholder="0" :inputtable="false"></vue-number-input>
						</div>
					</li>
					<li>
						<div class="desc">
							<span class="label">Dogs</span>
						</div>
						<div class="counter">
							<vue-number-input v-model="casiola.state.baseFilters.guests.pets" :min="0" :max="2"
								size="small" inline controls placeholder="0" :inputtable="false"></vue-number-input>
						</div>
						<div class="link">
							<a href="/guests/assistance-animals/" target="_blank">Bringing an assistance animal?</a>
						</div>
					</li>
				</ul>
			</div>
		</form>
		<div class="actions">
			<button aria-label="close" @click.stop.prevent="close">Update</button>
		</div>
	</div>
</template>
<script>
import gql from 'graphql-tag'
import { computed, watch, ref, defineAsyncComponent } from 'vue'
import VueNumberInput from '@chenfengyuan/vue-number-input';
import { useQuery } from '@vue/apollo-composable'
import { useCasiolaStore } from '@/store'
import { Interval } from 'luxon/src/luxon'
const Calendar = defineAsyncComponent(() => import('@/components/Calendar.vue'))

const query = gql`query Query {
  destinations {
    id
    name
	uri
  }
}`

export default {
	components: { VueNumberInput, Calendar },
	emits: ['close'],
	setup(props, context) {
		// CASIOLA STORE
		const casiola = useCasiolaStore()

		const close = () => {
			context.emit('close')
		}

		// LOCATION
		const destinations = ref([])
		const destinationsFiltered = computed(() => destinations.value.filter(d => d.id !== 4))
		const dest = computed({
			get: () => {
				return casiola.state.baseFilters.destinations.length ? casiola.state.baseFilters.destinations[0] : 'all'
			},
			set: (v) => {
				if (v === 'all') {
					casiola.state.baseFilters.destinations = []
				} else {
					casiola.state.baseFilters.destinations = [v]
				}
			}
		})
		const onQueryResult = (data) => {
			destinations.value = data.destinations
		}
		const { result, onResult } = useQuery(query);
		const handleResult = (data) => {
			onQueryResult(data)
		};
		watch(result, () => {
			if (!result.value) {
				return;
			}
			handleResult(result.value);
		}, {
			immediate: true
		});
		onResult(({ data }) => {
			if (data) {
				onQueryResult(data)
			}
		});

		// DATES
		// const getFormatDate = (date) => {
		// 	return format(new Date(date), 'dd/MM/yy')
		// }
		// const date = computed({
		// 	get: () => casiola.state.selectedDate,
		// 	set: d => {
		// 		casiola.state.selectedDate['start'] = d.start
		// 		casiola.state.selectedDate['end'] = d.end
		// 	}
		// })
		const nights = computed(() => {
            if (casiola.state.baseFilters.date.start && casiola.state.baseFilters.date.end) {
                return Math.round(Interval.fromDateTimes(casiola.state.baseFilters.date.start, casiola.state.baseFilters.date.end).toDuration('days').toObject().days)
            }
            return null
        })
		// GUESTS
		const guests = [
			{ label: 'Adults (12+)', body: "Ages 13 and above", key: 'adults' },
			{ label: 'Children', body: "Ages 0 - 12", key: 'children' },
			{ label: 'Dogs', body: null, key: 'pets' }
		]
		const totalGuests = computed(() => {
			return casiola.state.baseFilters.guests.adults + casiola.state.baseFilters.guests.children
		})
		// SEARCH
		const search = () => {
			let dest = '/all-destinations'
			if (casiola.state.baseFilters.destinations.length) {
				dest = destinations.value.find((d) => d.id === casiola.state.baseFilters.destinations[0]).uri
			}
			const url = new URL(`${window.location.protocol}//${window.location.hostname}${dest}/vacation-rentals`)
			casiola.state.baseFilters.destinations.length ? url.searchParams.append('destinationIds', casiola.state.baseFilters.destinations.join('+')) : null
			if (casiola.state.baseFilters.date.start) {
				url.searchParams.append('checkin', casiola.state.baseFilters.date.start.toFormat('yyyy-MM-dd'))
				url.searchParams.append('checkout', casiola.state.baseFilters.date.end.toFormat('yyyy-MM-dd'))
			}
			casiola.state.baseFilters.guests.adults ? url.searchParams.append('adults', casiola.state.baseFilters.guests.adults) : null
			casiola.state.baseFilters.guests.children ? url.searchParams.append('children', casiola.state.baseFilters.guests.children) : null
			casiola.state.baseFilters.guests.pets ? url.searchParams.append('pets', casiola.state.baseFilters.guests.pets) : null
			window.location.href = url
		}
		return {
			casiola,
			dest,
			destinations,
			destinationsFiltered,
			// getFormatDate,
			guests,
			totalGuests,
			search,
			// date,
			close,
			nights,
			// minDate,
			// maxDate
		}
	}
}
</script>
<style lang="scss" scoped>
* {
	box-sizing: border-box;
}

ul {
	list-style: none;
	margin: 0;
	padding: 0;

	li {
		margin: 0;
	}
}

#casiola-app-search-modal {
	width: 90%;
	max-width: 1140px;

	position: relative;
	padding: 2rem;
	background: #fff;
	border-radius: 20px;
	overflow: hidden;
	box-shadow: 0 0 1rem rgba(0, 0, 0, 0.25);
	display: grid;
	grid-template-columns: min-content 1fr;
	grid-auto-rows: dense;
	justify-content: space-between;
	gap: 2rem 10%;

	>button {
		position: absolute;
		top: 0;
		right: 0;
		width: 3rem;
		height: 3rem;
		z-index: 10;
		appearance: none;
		border: none;
		background: none;
		cursor: pointer;
	}

	form {
		h3 {
			font-size: 1.43rem;
			font-weight: 400;
			margin: 0 0 1rem;

			strong {
				font-weight: 800;
			}
		}

		&.location {
			ul {
				display: grid;
				gap: 0.5rem;
				margin-left: -1rem;

				label {
					span {
						display: flex;
						align-items: center;
						min-height: 36px;
						padding: 0.25rem 1rem;
						border-radius: 18px;
						cursor: pointer;
						transition: all 0.3s ease;
						user-select: none;
					}

					input {
						position: absolute;
						left: -9999px;
						clip-path: radius(0);

						&:checked {
							&+span {
								background: #ff0099;
								color: #fff;
							}
						}
					}
				}
			}
		}

		&.date {
			grid-row: span 2;
		}

		&.guests {
			grid-column: 1;

			ul {
				display: grid;
				gap: 1rem;

				li {
					display: grid;
					gap: 1rem 2rem;
					grid-template-columns: 1fr min-content;
					white-space: nowrap;

					.desc {
						display: grid;

						.body {
							font-size: 0.72rem;
							color: #808285;
						}
					}

					.link {
						grid-column: span 2;

						a {
							color: #ff0099;
						}
					}
				}
			}
		}
	}

	.actions {
		grid-column: 2;
		display: flex;
		justify-content: flex-end;

		button {
			appearance: none;
			border: none;
			height: 60px;
			width: 340px;
			background: #ff0099;
			color: #fff;
			font-size: 1.43rem;
			font-weight: 400;
			border-radius: 10px;
		}
	}
}
</style>